const formatFileSize = (size: number, unit = 1024) => {
  if (size < unit) {
    return `${size}B`;
  } else if (size < unit * unit) {
    return `${Math.round(size / unit)}KB`;
  } else if (size < unit * unit * unit) {
    return `${Math.round(size / (unit * unit))}MB`;
  } else {
    return `${(size / (unit * unit * unit)).toFixed(1)}GB`;
  }
};
export default formatFileSize;
